module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.4cd9e2ba.svg";